import createVueApp from '@/common/create_app'
import sidebar from '@/config/sidebars/admin_settings'

// Styxie derives name from Admin::Settings::MobileAppsController → AdminSettingsMobileApps
Styxie.Initializers.AdminSettingsMobileApps = {
  index: async(props) => {
    const { default: IndexPage } = await import('@/vue_widgets/admin/settings/mobile_apps/index/index.vue')
    createVueApp(IndexPage, { props, sidebar })
  },
  show: async(props) => {
    const { default: ShowPage } = await import('@/vue_widgets/admin/settings/mobile_apps/show/index.vue')
    createVueApp(ShowPage, { props, sidebar })
  },
  new: async(props) => {
    const { default: FormPage } = await import('@/vue_widgets/admin/settings/mobile_apps/form.vue')
    createVueApp(FormPage, { props, sidebar })
  },
  edit: async(props) => {
    const { default: FormPage } = await import('@/vue_widgets/admin/settings/mobile_apps/form.vue')
    createVueApp(FormPage, { props, sidebar })
  }
}
